import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { environment } from "src/environments/environment";
import { FormGroup, FormControl, Validators, FormBuilder, AbstractControl, ValidationErrors } from "@angular/forms";
import { QuotingToolService } from "../../quoting-tool.service";
import { NotificationService } from "src/app/core/services/notification.service";
import { PcbSpecification } from "src/app/core/interfaces/quoting-tool";
import * as moment from "moment";

@Component({
  selector: 'app-specifications',
  templateUrl: './specifications.component.html'
})
export class SpecificationsComponent implements OnInit {

  @Output() nextStep = new EventEmitter<void>();

  getImagePath: any = environment.image_path;
  dropdownOpen = false;
  minDate!: Date;
  updatepcbForm!: FormGroup;
  formSubmitted: boolean = false;
  testingForm!: FormGroup;
  PcbDateForm!: FormGroup;
  updatepcbFormSubmitted = false;
  updatemechanicalForm!: FormGroup;
  updatemechanicalFormSubmitted = false;
  updatecertificationForm!: FormGroup;
  updatecertificationFormSubmitted = false;
  isFormInvalid: boolean = true;
  isLoading: boolean = false;
  isStepComplited: boolean = false;
  stepComplited: any
  showPcbSpecifications: boolean = false;
  showMechanicalSpecifications: boolean = false;
  showAll3: boolean = false;
  tempComplianceDataArray: any
  isDropdownOpen: boolean = false;
  dropdownHasSelection: boolean = false;
  volumeByTimeData: any[] = [];
  materialData: any[] = [];
  surfaceFinishingData: any[] = [];
  copperThicknessData: any[] = [];
  pcbImpedanceData: any[] = [];
  solderMaskColorData: any[] = [];
  silkScreenColorData: any[] = [];
  coatingData: any[] = [];
  projectID: any;
  projectType: any;
  today = new Date();
  multiplierValues: number[] = [10, 25, 50, 100, 250, 500, 1000, 2500, 5000, 10000, 25000, 50000, 100000];
  designInPanelData: any[] = [];
  partMountingData: any[] = [];
  thicknessData: any[] = [];
  minTrackSpacingData: any[] = [];
  minHoleSizeData: any[] = [];
  viaProcessData: any[] = [];
  finishedCopperData: any[] = [];
  fR4TgData: any[] = [];
  goldfingersData: any[] = [];
  flexibleOptionData: any[] = [];
  boardTypeData: any[] = [];


  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  constructor(private quotingService: QuotingToolService, private notificationService: NotificationService, private fb: FormBuilder) {

  }

  ngOnInit(): void {
    this.projectID = localStorage.getItem('projectID');
    this.projectType = localStorage.getItem('projectType');
    this.stepComplited = localStorage.getItem('isStepComplited') || localStorage.getItem('currentStepIndex')
    this.GetSpecificaton();
    this.GetSpecificationDimentionsData();
    this.GetComplianceData();
    this.minDate = new Date();

    if (this.projectType === '1') {
      this.showPcbSpecifications = true;
      this.showAll3 = true;
    } else if (this.projectType === '2') {
      this.showMechanicalSpecifications = true;
      this.showAll3 = true;
    } else if (this.projectType === '3') {
      this.showPcbSpecifications = true;
      this.showMechanicalSpecifications = true;
      this.showAll3 = true;
    }

    this.updatepcbForm = new FormGroup({
      vDimensions: new FormControl('', [Validators.required, Validators.pattern(/^\S.*\S$/)]),
      vDimensionsMm: new FormControl('', [Validators.required, Validators.pattern(/^\S.*\S$/)]),
      vThikness: new FormControl("", [Validators.required]),
      vLayers: new FormControl("", [Validators.required, this.evenNumberValidator]),
      vPartmounting: new FormControl("1", [Validators.required]),
      vVolumebyTime: new FormControl("", [Validators.required]),
      quantityControl: new FormControl("", [Validators.required]),
      vTotalSMTJoints: new FormControl("", [Validators.required,Validators.pattern("^[1-9][0-9]*$")]),
      vTotalThroughHole: new FormControl("", [Validators.required, Validators.pattern("^[1-9][0-9]*$")]),
      vMaterial: new FormControl("", [Validators.required]),
      vSurfaceFinishing: new FormControl("", [Validators.required]),
      vCopperThikness: new FormControl("", [Validators.required]),
      vPCBImpendance: new FormControl("", [Validators.required]),
      vSolderMaskColor: new FormControl("", [Validators.required]),
      vSilkScreenColor: new FormControl("", [Validators.required]),
      vCoating: new FormControl("", [Validators.required]),
      vDesignInPanel: new FormControl("", [Validators.required]),
      vMinTrackSpacing: new FormControl("", [Validators.required]),
      vMinHoleSize: new FormControl("", [Validators.required]),
      vViaProcess: new FormControl("", [Validators.required]),
      vFinishedCopper: new FormControl("", [Validators.required]),
      vFR4Tg: new FormControl("", [Validators.required]),
      vGoldfingers: new FormControl("", [Validators.required]),
      vFlexibleOption: new FormControl("", [Validators.required]),
      vBoardType: new FormControl("", [Validators.required]),
      vLogoEtching: new FormControl("")
    });
    this.updatecertificationForm = new FormGroup({
      vComplianceCertification: new FormControl("", [Validators.required]),
    });
    this.PcbDateForm = new FormGroup({
      vDate: new FormControl(this.today),
      location: new FormControl('1')
    })
    this.testingForm = new FormGroup({
      testComment: new FormControl('')
    })

    this.updatepcbForm.get('quantityControl')?.valueChanges.subscribe(value => {
      // If value is an array and contains at least one element, then an option is selected.
      this.dropdownHasSelection = Array.isArray(value) && value.length > 0;
    });
  }

  onSelectionChange(): void {
    const selectedValues = this.updatepcbForm.get('quantityControl')?.value;
    if (selectedValues.length > 3) {
      // If more than 3 values are selected, slice the array to keep only the first 3
      this.updatepcbForm.get('quantityControl')?.setValue(selectedValues.slice(0, 3));
    }
  }

  isOptionDisabled(quantity: number): boolean {
    const selectedValues = this.updatepcbForm.get('quantityControl')?.value;
    // Disable the option if 3 values are already selected and the current option is not selected
    return selectedValues.length >= 3 && !selectedValues.includes(quantity);
  }

  imageSrc: string | ArrayBuffer | null = null;

  evenNumberValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value === null || value === '') {
      return null; // Don't validate empty values to allow optional controls
    }
    const isEven = parseInt(value) % 2 === 0;
    return isEven ? null : { evenNumber: true };
  }

  isImageUploaded = false;
  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files[0]) {
      const file = input.files[0];
      const reader = new FileReader();

      reader.onload = () => {
        this.imageSrc = reader.result;
        this.isImageUploaded = true;
      };

      reader.readAsDataURL(file);
    } else {
      this.isImageUploaded = false;
    }
    this.updatepcbForm.controls['vLogoEtching'].setValue(this.isImageUploaded ? "image" : "");
  }

  GetSpecificaton() {
    this.quotingService.GetSpecificationDropdownData().subscribe((resJSON: any) => {
      if (resJSON.code == 200) {
        this.volumeByTimeData = resJSON.data[0].VolumebyTimeData;
        this.coatingData = resJSON.data[1].CoatingData;
        this.materialData = resJSON.data[2].MaterialData;
        this.surfaceFinishingData = resJSON.data[3].SurfaceFinishingData;
        this.copperThicknessData = resJSON.data[4].CopperThicknessData;
        this.pcbImpedanceData = resJSON.data[5].PCBImpedanceData;
        this.solderMaskColorData = resJSON.data[6].SolderMaskColorData;
        this.silkScreenColorData = resJSON.data[7].SilkScreenColorData;
        this.partMountingData = resJSON.data[8].PartMountingData;
        this.designInPanelData = resJSON.data[9].DesignInPanelData;
        this.minTrackSpacingData = resJSON.data[10].MinTrackSpacingData;
        this.minHoleSizeData = resJSON.data[11].MinHoleSizeData;
        this.viaProcessData = resJSON.data[12].ViaProcessData;
        this.finishedCopperData = resJSON.data[13].FinishedCopperData;
        this.fR4TgData = resJSON.data[14].FR4TgData;
        this.goldfingersData = resJSON.data[15].GoldfingersData;
        this.flexibleOptionData = resJSON.data[16].FlexibleOptionData;
        this.boardTypeData = resJSON.data[17].BoardTypeData;
        this.thicknessData = resJSON.data[18].ThicknessData;
        
        this.updatepcbForm.patchValue({
          vVolumebyTime: this.volumeByTimeData.length > 0 ? this.volumeByTimeData[0].id : '',
          vMaterial: this.materialData.length > 0 ? this.materialData[0]._id : '',
          vSurfaceFinishing: this.surfaceFinishingData.length > 0 ? this.surfaceFinishingData[0]._id : '',
          vCopperThikness: this.copperThicknessData.length > 0 ? this.copperThicknessData[0]._id : '',
          vPCBImpendance: this.pcbImpedanceData.length > 0 ? this.pcbImpedanceData[0]._id : '',
          vSolderMaskColor: this.solderMaskColorData.length > 0 ? this.solderMaskColorData[1]._id : '',
          vSilkScreenColor: this.silkScreenColorData.length > 0 ? this.silkScreenColorData[1]._id : '',
          vCoating: this.coatingData.length > 0 ? this.coatingData[1].id : '',
          vDesignInPanel: this.designInPanelData.length > 0 ? this.designInPanelData[0].id : '',
          vPartmounting: this.partMountingData.length > 0 ? this.partMountingData[0].id : '',
          vMinTrackSpacing: this.minTrackSpacingData.length > 0 ? this.minTrackSpacingData[3].id : '',
          vMinHoleSize: this.minHoleSizeData.length > 0 ? this.minHoleSizeData[3].id : '',
          vViaProcess: this.viaProcessData.length > 0 ? this.viaProcessData[0].id : '',
          vFinishedCopper: this.finishedCopperData.length > 0 ? this.finishedCopperData[1].id : '',
          vFR4Tg: this.fR4TgData.length > 0 ? this.fR4TgData[1].id : '',
          vGoldfingers: this.goldfingersData.length > 0 ? this.goldfingersData[1].id : '',
          vFlexibleOption: this.flexibleOptionData.length > 0 ? this.flexibleOptionData[0].id : '',
          vBoardType: this.boardTypeData.length > 0 ? this.boardTypeData[0].id : '',
          vThikness: this.thicknessData.length > 0 ? this.thicknessData[7].id : '',
        });
        // if(this.stepComplited == 1){
        this.GetGerberPCBDetailsbyID();
        // }
      }
    })
  }

  selectedIds: number[] = [];
  onCheckboxChange(event: any, id: number) {
    if (event.target.checked) {
      if (!this.selectedIds.includes(id)) {
        this.selectedIds.push(id);
      }
    } else {
      const index = this.selectedIds.indexOf(id);
      if (index > -1) {
        this.selectedIds.splice(index, 1);
      }
    }
  }
  isChecked(id: any): boolean {
    return this.selectedIds.includes(id);
  }


  UpdatePCB() {
    this.updatepcbForm.markAllAsTouched();
    this.formSubmitted = true;

    const throughHoleValue = this.updatepcbForm.get('vTotalThroughHole')?.value;

    // Check if it's empty, null, or zero
    if (!throughHoleValue || throughHoleValue.toString().trim() === '0') {
        this.notificationService.showError("No. of through holes joint cannot be zero.", "");
        return;
    }

    const selectedValues = this.updatepcbForm.get('quantityControl')?.value || [];
    const formattedValuess = selectedValues.map((value: any) => value.toString()).join(',');


    if (this.updatepcbForm.invalid) {
      // this.notificationService.showError("Please fill in all required fields.", "");
      return;
    }
    const formattedValues = Array.from(this.selectedIds).join(',');
    let formattedDate = this.PcbDateForm.value.vDate;
    let selectedDate = moment(formattedDate);
    let formattedSelectedDate = selectedDate.format("M/D/YYYY");

    const vDimensionsValue = this.updatepcbForm.get('vDimensions')?.value ?? '';
    const vDimensionsMmValue = this.updatepcbForm.get('vDimensionsMm')?.value ?? '';

    const combinedValue = `${vDimensionsValue}X${vDimensionsMmValue}mm`;

    const reqJSON: PcbSpecification = {
      vProjectType: Number(this.projectType),
      vDimensions: combinedValue,
      vThikness: this.updatepcbForm.value.vThikness,
      vLayers: this.updatepcbForm.value.vLayers,
      vPartmounting: this.updatepcbForm.value.vPartmounting,
      vQuantities: formattedValuess,
      vVolumebyTime: this.updatepcbForm.value.vVolumebyTime,
      vVolumebyUnit: 1,
      vTotalSMTJoints: this.updatepcbForm.value.vTotalSMTJoints,
      vTotalThroughHole: this.updatepcbForm.value.vTotalThroughHole,
      vMaterial: this.updatepcbForm.value.vMaterial,
      vSurfaceFinishing: this.updatepcbForm.value.vSurfaceFinishing,
      vCopperThikness: this.updatepcbForm.value.vCopperThikness,
      vPCBImpendance: this.updatepcbForm.value.vPCBImpendance,
      vSolderMaskColor: this.updatepcbForm.value.vSolderMaskColor,
      vSilkScreenColor: this.updatepcbForm.value.vSilkScreenColor,
      vCoating: this.updatepcbForm.value.vCoating,
      vDesignInPanel: this.updatepcbForm.value.vDesignInPanel,
      vMinTrackSpacing: this.updatepcbForm.value.vMinTrackSpacing,
      vMinHoleSize: this.updatepcbForm.value.vMinHoleSize,
      vViaProcess: this.updatepcbForm.value.vViaProcess,
      vFinishedCopper: this.updatepcbForm.value.vFinishedCopper,
      vFR4Tg: this.updatepcbForm.value.vFR4Tg,
      vGoldfingers: this.updatepcbForm.value.vGoldfingers,
      vFlexibleOption: this.updatepcbForm.value.vFlexibleOption,
      vBoardType: this.updatepcbForm.value.vBoardType,
      // vLogoEtching: typeof this.imageSrc === 'string' ? this.imageSrc : '',
      vComplianceCertification: formattedValues,
      vIntendedStartDate: formattedSelectedDate,
      vManufactureLocation: this.PcbDateForm.value.location,
      vTesting: this.testingForm.value.testComment
    };

    if (this.isImageUploaded) {
      reqJSON.vLogoEtching = typeof this.imageSrc === 'string' ? this.imageSrc : '';
  }

    this.quotingService.PcbSpecification(this.projectID, reqJSON).subscribe((resJSON: any) => {
      if (resJSON.code == 200) {
        this.nextStep.emit();
        this.updatepcbForm.reset();
        this.isStepComplited = true;
        localStorage.setItem('isStepComplited', JSON.stringify(1))
        this.notificationService.showSuccess(`${resJSON.message}`, "");
        this.isLoading = false;
        const newValue = Math.random() * 100;
        this.quotingService.updateStepper(newValue);
      } else {
        this.isLoading = false;
        this.notificationService.showError(`${resJSON.message}`, "");
      }
    });
  }

  GetGerberPCBDetailsbyID() {
    this.quotingService.GetGerberPCBDetailsbyID(this.projectID).subscribe(async (resJSON: any) => {
      if (resJSON.code === 200) {
        let tempPcbDetails = resJSON.data[0];
        let pcbDetails = tempPcbDetails;
        this.patchValue(pcbDetails);
        // this.notificationService.showSuccess(`${resJSON.message}`, "");
      } else {
        this.notificationService.showError(`${resJSON.message}`, "");
      }
    });
  }

  patchValue(pcbDetails: any) {

    const specData = pcbDetails?.vSpecficationPCBData;

    if (specData) {
      this.selectedIds = pcbDetails.vComplianceCertification.split(',');

      const rawQuantities = pcbDetails?.vSpecficationPCBData?.vQuantities ?? "";

      // Convert string to number array
      const quantitiesArray = rawQuantities
        ? rawQuantities.split(',').map((q: any) => Number(q.trim())).filter((q: any) => !isNaN(q))
        : [];

      this.updatepcbForm.patchValue({
        vThikness: pcbDetails.vSpecficationPCBData.vThikness,
        vLayers: pcbDetails.vSpecficationPCBData.vLayers,
        quantityControl: quantitiesArray,
        vTotalSMTJoints:
          (pcbDetails.vSpecficationPCBData.vTotalSMTJoints === null || pcbDetails.vSpecficationPCBData.vTotalSMTJoints === 0)
            ? ""
            : pcbDetails.vSpecficationPCBData.vTotalSMTJoints,
        vTotalThroughHole:
          (pcbDetails.vSpecficationPCBData.vTotalThroughHole === null || pcbDetails.vSpecficationPCBData.vTotalThroughHole === 0)
            ? ""
            : pcbDetails.vSpecficationPCBData.vTotalThroughHole,
        vMaterial: pcbDetails.vSpecficationPCBData.vMaterial,
        vSurfaceFinishing: pcbDetails.vSpecficationPCBData.vSurfaceFinishing,
        vCopperThikness: pcbDetails.vSpecficationPCBData.vCopperThikness,
        vPCBImpendance: pcbDetails.vSpecficationPCBData.vPCBImpendance,
        vSolderMaskColor: pcbDetails.vSpecficationPCBData.vSolderMaskColor,
        vSilkScreenColor: pcbDetails.vSpecficationPCBData.vSilkScreenColor,
        vCoating: pcbDetails.vSpecficationPCBData.vCoating,
        vDesignInPanel: pcbDetails.vSpecficationPCBData.vDesignInPanel,
        vpartmounting: pcbDetails.vSpecficationPCBData.vPartmounting,
        vMinTrackSpacing: pcbDetails.vSpecficationPCBData.vMinTrackSpacing,
        vMinHoleSize: pcbDetails.vSpecficationPCBData.vMinHoleSize,
        vViaProcess: pcbDetails.vSpecficationPCBData.vViaProcess,
        vFinishedCopper: pcbDetails.vSpecficationPCBData.vFinishedCopper,
        vFR4Tg: pcbDetails.vSpecficationPCBData.vFR4Tg,
        vGoldfingers: pcbDetails.vSpecficationPCBData.vGoldfingers,
        vFlexibleOption: pcbDetails.vSpecficationPCBData.vFlexibleOption,
        vBoardType: pcbDetails.vSpecficationPCBData.vBoardType,
      });

      this.PcbDateForm.patchValue({
        vDate: new Date(pcbDetails.vIntendedStartDate),
        location: pcbDetails.vManufactureLocation.toString(),
      });


      this.testingForm.patchValue({
        testComment: pcbDetails.vTesting
      })

      this.formSubmitted = true;

      this.imageSrc = pcbDetails.vSpecficationPCBData.vLogoEtching;
    }
  }

  GetComplianceData() {
    this.quotingService.GetComplianceData().subscribe(async (resJSON: any) => {
      if (resJSON.code === 200) {
        this.tempComplianceDataArray = resJSON.data;
      } else {
        this.notificationService.showError(`${resJSON.message}`, "");
      }
    });
  }

  GetSpecificationDimentionsData() {
    this.quotingService.GetSpecificationDimentionsData(this.projectID).subscribe(async (resJSON: any) => {
      if (resJSON.code === 200) {
        let tempDimetions = resJSON.data[0];
        if (tempDimetions) {
          let dimentionsDetails = tempDimetions;
          this.patchValueOfDimentions(dimentionsDetails);
          // this.notificationService.showSuccess(`${resJSON.message}`, "");
        } else {
          // this.notificationService.showError("No PCB details available.", "");
        }
      } else {
        this.notificationService.showError(`${resJSON.message}`, "");
      }
    });
  }

  patchValueOfDimentions(dimentionsDetails: any) {
    const specData = dimentionsDetails
    if (dimentionsDetails.vDimensions) {
      let dimensions = dimentionsDetails.vDimensions.toUpperCase().replace('MM', '').split('X');
      let width = dimensions[0] ? dimensions[0].trim() : '';
      let height = dimensions[1] ? dimensions[1].trim() : '';
      this.updatepcbForm.patchValue({
        vDimensions: width,
        vDimensionsMm: height
      });
    }
    this.updatepcbForm.patchValue({
      vLayers: dimentionsDetails.vLayers,
      vThikness: dimentionsDetails.vThikness,
      vPartmounting: dimentionsDetails.vPartmounting,
      vTotalSMTJoints: dimentionsDetails.vTotalSMTJoints,
      vTotalThroughHole: dimentionsDetails.vTotalThroughHole
    });
  }

  isFormValid(): boolean {
    this.updatepcbForm.markAllAsTouched();
    return this.updatepcbForm.valid;
  }
}
